export var ComplianceType;
(function (ComplianceType) {
    ComplianceType["PRIVACY_POLICY"] = "PRIVACY_POLICY";
    ComplianceType["REMEMBER_ME"] = "REMEMBER_ME";
    ComplianceType["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
    ComplianceType["COOKIE"] = "COOKIE";
    ComplianceType["GEOLOCATION"] = "GEOLOCATION";
})(ComplianceType || (ComplianceType = {}));
//# sourceMappingURL=ComplianceType.js.map